import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { UnauthGuard } from 'app/auth/unauth.guard';
import { ErrorComponent } from './layouts';

const APP_ROUTES: Routes = [{
  path: 'auth',
  canLoad: [UnauthGuard],
  canActivate: [UnauthGuard],
  canActivateChild: [UnauthGuard],
  loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule)
}, {
  path: 'error',
  component: ErrorComponent,
  data: {
    authorities: [],
    pageTitle: $localize`:@@error.title:Something went wrong`
  },
}, {
  path: 'accessdenied',
  component: ErrorComponent,
  data: {
    authorities: [],
    pageTitle: $localize`:@@error.403title:Unauthorized`
  },
}, {
  path: '**',
  redirectTo: '/core/admin/organization'
}];

@NgModule({
  imports: [
    RouterModule.forRoot(APP_ROUTES, {
      useHash: false
    }),
  ],
  exports: [
    RouterModule,
  ],
})
export class AppRoutingModule {
}
